/**
 * package: com.inq.utils
 * class: Timer
 * @extends haxe.Timer 
 * @constructor
 */
com.inq.utils.Timer = function(time_ms) {
	haxe.Timer.call(this,time_ms);
};
$hxClasses['com.inq.utils.Timer'] = com.inq.utils.Timer;
/** @private @type {Array} */
com.inq.utils.Timer.__name__ = ["com","inq","utils","Timer"];
/** @private @type {Function} */
com.inq.utils.Timer.__super__ = haxe.Timer;
for(var k in haxe.Timer.prototype ) com.inq.utils.Timer.prototype[k] = haxe.Timer.prototype[k];

/**
 * delay
 *
 * $type TFun([{ name => f, t => TFun([],TEnum(Void,[])), opt => false },{ name => time_ms, t => TInst(Int,[]), opt => false }],TInst(com.inq.utils.Timer,[]))
 * @public
 * @static
 * @param {TFun([],TEnum(Void,[]))}  f 
 * @param {number}  time_ms 
 * @return {com.inq.utils.Timer}
 */
com.inq.utils.Timer.delay = function(f,time_ms) {
	/** @type {com.inq.utils.Timer} */
	var t = new com.inq.utils.Timer(time_ms);
	t.run = function() {
		t.stop();
		f();
	};
	return t;
};

/** @type {com.inq.utils.Timer} */
com.inq.utils.Timer.prototype.__class__ = com.inq.utils.Timer;
